<template>
<nav :class="{sidebar: true, sidebarStatic, sidebarOpened}">
  <header class="logo">
    <router-link to="/app/main/dashboard"><span class="text-kelvatek text">LineSIGHT</span> Web</router-link>
  </header>
  <ul class="nav" v-if="$base.isAllowed('view')">
    <NavLink :activeItem="activeItem" header="Dashboard" link="/app/main/dashboard" iconName="flaticon-home" index="main" isHeader />
    <NavLink  v-if="$base.isAllowed('viewMainsSupply')" :activeItem="activeItem" header="Mains Outage" link="/app/main/mainsOutage" iconName="flaticon-dislike-1" index="main" isHeader />
    <NavLink :activeItem="activeItem" header="Devices" link="/app/main/devices" iconName="flaticon-list" index="main" isHeader />
    <NavLink :activeItem="activeItem" header="Upgrades" link="/app/main/upgrades" iconName="flaticon-upload" index="main" isHeader />
    <NavLink :activeItem="activeItem" header="Diagnostic" link="/app/main/diagnostic" iconName="flaticon-server-1" index="main" isHeader />
  </ul>
  <Footer sidebar/>
</nav>
</template>

<script>
import {
  mapState,
  mapActions
} from 'vuex';
import NavLink from './NavLink/NavLink';
import Footer from '@/components/Footer/Footer';

export default {
  name: 'Sidebar',
  components: {
    NavLink,
    Footer
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions('layout', ['changeSidebarActive', 'switchSidebar']),
    setActiveByRoute() {
      const paths = this.$route.fullPath.split('/');
      paths.pop();
      this.changeSidebarActive(paths.join('/'));
    }
  },
  created() {
    this.setActiveByRoute();
  },
  computed: {
    ...mapState('layout', {
      sidebarStatic: state => state.sidebarStatic,
      sidebarOpened: state => !state.sidebarClose,
      activeItem: state => state.sidebarActiveElement,
    })
  },
};
</script>

<!-- Sidebar styles should be scoped -->
<style src="./Sidebar.scss" lang="scss" scoped/>
